import React from 'react';
import { Button, Result } from 'antd';
const Pagenofound = () => (
    <Result
        style={{ minHeight: "100vh", display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: "column" }}
        status="403"
        title="403"
        subTitle="you are not authorized to access this page."
        extra={<Button type="primary" onClick={() => window.location.href = ("/")}>Back Home</Button>}
    />
);
export default Pagenofound;